import { h } from 'preact';

function KeyOutlined() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_key_outlined)">
                <path d="M8 16C6.34315 16 5 14.6569 5 13C5 11.3431 6.34315 10 8 10C9.65685 10 11 11.3431 11 13C11 14.6569 9.65685 16 8 16Z" stroke="white" strokeWidth="1.5" fill="none"/>
                <path d="M11 13H20M16 9V11M18 7V9" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_key_outlined">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default KeyOutlined;